import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4601Model } from '../kymw4601.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * タグ集約サービス
 *
 * @export AggregateTagService
 * @class AggregateTagService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class AggregateTagService extends PlessJsonResponderSub<any> {
  private model: KYMW4601Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof AggregateTagService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        AggregationTagId: this.model.aggregationTagId,
        TargetTagIds: this.model.targetTagIds.join(','),
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param f
   * @memberof AggregateTagService
   */
  execute(model: KYMW4601Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('aggregateTag', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof AggregateTagService
   */
  success() {
    if (this.calbak) this.calbak();
  }
}
